// @flow

import * as React from "react";
import { withRouter } from "react-router-dom";
import AppLayout, {
  PrimaryNavItem,
  UtilityNavItem,
} from "@vimcar/shared-components/components/AppLayout";
import linkViewModel from "@vimcar/shared-utils/linkViewModel";

import WalkthroughWrapper from "#components/WalkthroughWrapper";
import { VimcarBookingLogomarkNeutralInverse } from "#components/VimcarBookingLogomarkNeutralInverse";
import i18n from "#utils/i18n";
import mkViewModel, { type ViewModel } from "./viewModel";
import styles from "./styles.css";

const tp = i18n.prefix("components.Dashboard");

type Props = {
  viewModel: ViewModel,
  children: React.Node,
};

const Dashboard = ({ children, viewModel }: Props) => {
  const content = (
    <React.Fragment>
      {viewModel.showLayout && (
        <WalkthroughWrapper
          run={viewModel.showSettingsWalkThrough}
          walkThroughSteps={viewModel.settingsWalkThroughSteps}
        />
      )}
      {children}
    </React.Fragment>
  );

  return viewModel.showLayout ? (
    <div ref={viewModel.appLayoutRef}>
      <AppLayout theme="dark">
        <PrimaryNavItem
          icon="car"
          path="/dashboard/new-booking"
          title={tp("new-booking")}
        />
        <PrimaryNavItem
          icon="calendar"
          path="/dashboard/bookings"
          title={tp("my-bookings")}
        />
        {viewModel.showLinkToAdmin && (
          <PrimaryNavItem
            external
            path="https://fleet.vimcar.com"
            rel="noopener"
            target="_blank"
            title={
              <div
                style={{
                  marginLeft: 2,
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <VimcarBookingLogomarkNeutralInverse
                  height={20}
                  width={20}
                  fill="currentColor"
                  style={{ flexShrink: 0 }}
                />
                {tp("fleet")}
              </div>
            }
          />
        )}
        <UtilityNavItem
          icon="person"
          path="/dashboard/profile"
          title={viewModel.givenName}
        />
        <UtilityNavItem icon="logout" path="/logout" title="Logout" />

        {content}
      </AppLayout>
    </div>
  ) : (
    <div className={styles.kioskModeWrapper}>{content}</div>
  );
};

export default withRouter(linkViewModel(mkViewModel, Dashboard));
